module.exports = __webpack_public_path__ + "static/deal_templates-8c4c0cd2e99d99dc9bb9977e1bb8a30d.png";